/* eslint-disable no-console */
import {Divider, Flex} from 'antd';
import React from 'react';

import scopeImage from '../../../../assets/scopeImage.png';
import BlockAccessPage from '../../../../components/BlockAccess/BlockAccessPage';
import PageContent from '../../../../components/PageContent/PageContent';
import sumTableValue from '../../../../components/Table/Utils/sumTableValue';
import {
  blockAccessTypes,
  blockModelMessages,
  blockModelTypes
} from '../../../../constants/blockPageConstatnts';
import {formatIndian} from '../../../../utils/formatIndian';
import {roundToDecimal} from '../../../netZero/constants/commonFunctions';

import {DataScope} from './CommonData';

const Scope: React.FC<{
  scopeData: DataScope[];
  scopeNumber: number;
  scopeColor: string;
  color: string;
  isBlock: boolean;
}> = ({scopeData = [], scopeNumber, scopeColor, color, isBlock}) => {
  return (
    <PageContent>
      <Flex
        style={{
          flexDirection: 'column',
          height: '31.5rem'
        }}
      >
        <Flex style={{flexDirection: 'row', justifyContent: 'space-between'}}>
          <Flex
            className="scopeNumberMainFlex"
            style={{
              backgroundColor: scopeColor,
              color
            }}
          >
            <div className="scopeNumber">{scopeNumber}</div>
            <div className="scopeText">SCOPE</div>
            <div
              className="backgroundDiv"
              style={{
                backgroundColor: color
              }}
            ></div>
          </Flex>
          {isBlock ? null : (
            <Flex className="rightFlex">
              <Flex
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <Flex className="imageFlex">
                  <img src={scopeImage} height={48} width={48} />
                </Flex>
                <div className="sumEmission">
                  <div>
                    {formatIndian(
                      roundToDecimal(
                        sumTableValue(scopeData, 'value', false) as number
                      )
                    )}
                    <span style={{marginLeft: '8px'}}>tCO2e</span>
                  </div>
                </div>
              </Flex>
              <div className="totalCarbonEmission">TOTAL EMISSION</div>
            </Flex>
          )}
        </Flex>
        <Divider />
        {isBlock ? (
          <BlockAccessPage
            messageTitle={blockModelMessages.scope.title.unlockMessage(
              scopeNumber?.toString()
            )}
            messageDescription={blockModelMessages.scope.description.message(
              scopeNumber?.toString()
            )}
            blockedType={blockAccessTypes.PARTIAL}
            modelType={blockModelTypes.SCOPE_NORMAL}
          />
        ) : null}
        {isBlock ? null : (
          <>
            <Flex className="emissionByTitle">
              <div>EMISSION BY</div>
              <div>tCO2e</div>
            </Flex>
            <div style={{overflow: 'scroll'}}>
              {scopeData?.map((scopeData, index) => (
                <div key={index}>
                  <Flex
                    className="listEmission"
                    style={{
                      color,
                      backgroundColor: scopeColor,
                      padding: '0px 24px'
                    }}
                  >
                    <div>{scopeData?.label}</div>
                    <div>{formatIndian(scopeData?.value)}</div>
                  </Flex>
                </div>
              ))}
            </div>
          </>
        )}
      </Flex>
    </PageContent>
  );
};

export default Scope;
